import { isNativeApp } from "./platform"

export const APP_ENVIRONMENTS = {
  develop: {
    label: "Develop",
    url: process.env.NEXT_PUBLIC_APP_API_DEVELOP_URL || "https://dev-g3-api.dkro.com.br",
    webUrl: process.env.NEXT_PUBLIC_APP_WEB_DEVELOP_URL || "https://dev-g3.dkro.com.br",
  },
  homolog: {
    label: "Homolog",
    url: process.env.NEXT_PUBLIC_APP_API_HOMOLOG_URL || "https://hml-g3-api.dkro.com.br",
    webUrl: process.env.NEXT_PUBLIC_APP_WEB_HOMOLOG_URL || "https://hml-g3.dkro.com.br",
  },
  staging: {
    label: "Staging",
    url: process.env.NEXT_PUBLIC_APP_API_STAGING_URL || "https://g3-api.dkro.com.br",
    webUrl: process.env.NEXT_PUBLIC_APP_WEB_STAGING_URL || "https://g3.dkro.com.br",
  },
  production: {
    label: "Production",
    url: process.env.NEXT_PUBLIC_APP_API_PRODUCTION_URL || "https://g3-api.dkro.com.br",
    webUrl: process.env.NEXT_PUBLIC_APP_WEB_PRODUCTION_URL || "https://g3.dkro.com.br",
  },
} as const

export type AppEnvironment = keyof typeof APP_ENVIRONMENTS
export const APP_ENVIRONMENT_KEY = "dkro.app-environment"

// Build flag: set to "false" to hide the selector in the compiled app.
// The current environment label remains visible on the login screen.
export const SHOW_APP_ENVIRONMENT_SELECTOR = process.env.NEXT_PUBLIC_APP_SHOW_ENVIRONMENT_SELECTOR !== "false"

export function canSelectAppEnvironment(): boolean {
  return isNativeApp() && SHOW_APP_ENVIRONMENT_SELECTOR
}

export function isAppEnvironment(value: unknown): value is AppEnvironment {
  return typeof value === "string" && Object.hasOwn(APP_ENVIRONMENTS, value)
}

const configuredDefault = process.env.NEXT_PUBLIC_APP_DEFAULT_ENVIRONMENT
export const DEFAULT_APP_ENVIRONMENT: AppEnvironment = isAppEnvironment(configuredDefault)
  ? configuredDefault
  : "develop"

function readEnvironment(): AppEnvironment {
  if (!isNativeApp()) return DEFAULT_APP_ENVIRONMENT
  try {
    const saved = window.localStorage.getItem(APP_ENVIRONMENT_KEY)
    return isAppEnvironment(saved) ? saved : DEFAULT_APP_ENVIRONMENT
  } catch {
    return DEFAULT_APP_ENVIRONMENT
  }
}

// Keep a snapshot for this WebView load: requests already in flight must never
// switch hosts or storage scopes while the new choice is being persisted.
export const ACTIVE_APP_ENVIRONMENT = readEnvironment()

export function environmentStorageKey(key: string): string {
  return isNativeApp() ? `${key}:${ACTIVE_APP_ENVIRONMENT}` : key
}

export function saveAppEnvironment(environment: AppEnvironment): void {
  if (!isNativeApp()) throw new Error("A troca de ambiente está disponível apenas no aplicativo.")
  if (!isAppEnvironment(environment)) throw new Error("Ambiente inválido.")
  window.localStorage.setItem(APP_ENVIRONMENT_KEY, environment)
}
